import script from "./editedMessage.vue?vue&type=script&setup=true&lang=ts"
export * from "./editedMessage.vue?vue&type=script&setup=true&lang=ts"

import "./editedMessage.vue?vue&type=style&index=0&id=5434a2f6&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5434a2f6"]])

export default __exports__